import { AppDispatch } from '../../redux/store';
import { CalendarEventObject } from '../../params/redux/calendar';
import CardWrapper from '../wrapper/card';
import DeleteMeetingModal from './modal/delete_meeting';
import { formatDate } from '../../helper';
import ImageClass from '../../assets';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { Box, Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { CopyAll, Delete, Edit, MoreVert, OpenInNew } from '@mui/icons-material';
import { settingAddingGoogleEvent, settingAddingGoogleMeeting, settingEditNotificationFlag, settingSelectedEvent } from '../../redux/slices/calendar';

interface MeetingEventComponentProps {
    event: CalendarEventObject;
}

const MeetingComponent = ({ event }: MeetingEventComponentProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [deleteModal, setDeleteModal] = useState<number>(0);
    const [showAttendee, setShowAttendee] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleButtonClick = (eventFromButton: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(eventFromButton.currentTarget);
    };

    const handleAttendeeClick = (eventFromButton: React.MouseEvent<HTMLButtonElement>) => {
        setShowAttendee(eventFromButton.currentTarget);
    };

    const editEventHandler = () => {
        dispatch(settingSelectedEvent(event));
        dispatch(settingAddingGoogleEvent(false));
        dispatch(settingAddingGoogleMeeting(true));
    };

    const deleteEventHandler = () => {
        dispatch(settingSelectedEvent(event));
        setDeleteModal(event.id);
    };

    const editNotificationHandler = () => {
        dispatch(settingSelectedEvent(event));
        dispatch(settingEditNotificationFlag(true));
    };

    return (
        <CardWrapper sx={{
            minHeight: '240px'
        }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight="700" color="textSecondary">
                    {event?.event_name || 'Untitled Event'}
                </Typography>
                <IconButton onClick={handleButtonClick}><MoreVert color="disabled" /></IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                    MenuListProps={{
                        'aria-labelledby': 'add-pipeline-button'
                    }}
                >
                    <MenuItem sx={{ display: 'none' }} onClick={editEventHandler}>
                        <Box display="flex" alignItems="center" gap={2}><Edit color="disabled" /> <Typography color="textSecondary" variant="body2">Edit event</Typography></Box>
                    </MenuItem>
                    <MenuItem onClick={deleteEventHandler}>
                        <Box display="flex" alignItems="center" gap={2}><Delete color="disabled" /> <Typography color="textSecondary" variant="body2">Delete event</Typography></Box>
                    </MenuItem>
                </Menu>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
                <Typography variant="body2" color="textSecondary">
                    {formatDate(event?.set_date || '1970-01-01T00:00:00Z', {
                        month: 'long',
                        year: 'numeric',
                        day: '2-digit'
                    }) || 'No Date'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {event?.set_time || 'Date not available'}
                </Typography>
            </Box>
            {event.platform === 'meet' && <Box display="flex" alignItems="center" gap="5px">
                <img src={ImageClass.googleMeetLogo} alt="Google Meet" height="30px" /> <Typography variant="subtitle1" color="textDisabled">Google Meeting</Typography> {(
                    <IconButton href={event?.meeting_link || '#'} target="_blank">
                        <OpenInNew fontSize="small" color="primary" />
                    </IconButton>
                )}
            </Box>}
            <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
                <Button onClick={handleAttendeeClick} variant="text" size="small">
                    View Attendees
                </Button>
                {(event?.meeting_attendees?.length ?? 0) > 0 && <Menu
                    anchorEl={showAttendee}
                    open={Boolean(showAttendee)}
                    onClose={() => setShowAttendee(null)}
                    MenuListProps={{
                        'aria-labelledby': 'add-pipeline-button'
                    }}
                >
                    {
                        event.meeting_attendees?.map((item, index) => (
                            <MenuItem key={index}>
                                <Typography variant="body2" color="textSecondary">{item.email}</Typography>
                            </MenuItem>
                        ))
                    }
                </Menu>}
                {!event.calendar_link_id && event.meeting_link && <Button
                    variant="text"
                    startIcon={<CopyAll />}
                    onClick={() => navigator.clipboard.writeText(event.meeting_link as string)}
                >Copy Link</Button>}
            </Box>
            {event.calendar_link_id && <Box display="flex" justifyContent={event.calendar_link_id ? 'space-between' : 'end'}>
                <Button variant="text" size="small" onClick={editNotificationHandler}>
                    Edit Notifications
                </Button>
                {event.meeting_link && <Button
                    variant="text"
                    startIcon={<CopyAll />}
                    onClick={() => navigator.clipboard.writeText(event.meeting_link as string)}
                >Copy Link</Button>}
            </Box>}
            {deleteModal === event.id && <DeleteMeetingModal open={deleteModal === event.id} onClose={() => setDeleteModal(0)} />}
        </CardWrapper>
    );
};

export default MeetingComponent;